<div class="py-3">
    <div class="container">
        <div class="back-btn text-start">
            <a role="btn" routerLink="/teams" title="تحديث البيانات">
                <i class="ri-arrow-left-line"></i>
            </a>
        </div>
        <form [formGroup]="createTeamFrom">
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="teamColor" class="form-label">
                            لون الفريق
                        </label>
                        <ng-select [notFoundText]="'لا يوجد عناصر متاحة'" [clearable]="false" [items]="colors"
                            bindLabel="name" [virtualScroll]="true" bindValue="hexCode" formControlName="color">
                            <ng-template ng-label-tmp let-item="item">
                                <span class="bg__circle ms-3 me-2" [style.background-color]="item.hexCode"></span>
                                {{item.name}}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                                <div class="d-flex align-items-center">
                                    <span class="bg__circle ms-3" [style.background-color]="item.hexCode"></span>
                                    {{item.name}}
                                </div>
                            </ng-template>
                        </ng-select>
                        <div class="form-control-feedback text-end"
                            *ngIf="((createTeamFrom.get('color')?.touched) && (createTeamFrom.get('color')?.invalid))">
                            <small *ngIf="createTeamFrom.get('color')?.errors?.['required']" class="text-danger">
                                هذا الحقل مطلوب
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="teamName" class="form-label">
                            اسم الفريق
                        </label>
                        <input type="text" class="form-control" id="teamName" placeholder="اسم الفريق"
                            formControlName="name">
                        <div class="form-control-feedback text-end"
                            *ngIf="((createTeamFrom.get('name')?.touched) && (createTeamFrom.get('name')?.invalid))">
                            <small *ngIf="createTeamFrom.get('name')?.errors?.['required']" class="text-danger">
                                هذا الحقل مطلوب
                            </small>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label for="camelsNumber" class="form-label">
                            عدد الجمال
                        </label>
                        <input type="number" class="form-control" id="teamName" placeholder="عدد الجمال"
                            formControlName="playersNo">
                        <div class="form-control-feedback text-end"
                            *ngIf="((createTeamFrom.get('playersNo')?.touched) && (createTeamFrom.get('playersNo')?.invalid))">
                            <small *ngIf="createTeamFrom.get('playersNo')?.errors?.['required']" class="text-danger">
                                هذا الحقل مطلوب
                            </small>
                            <small *ngIf="createTeamFrom.get('playersNo')?.errors?.['pattern']" class="text-danger">
                                يجب ادخال ارقام فقط
                            </small>
                            <!-- <small *ngIf="createTeamFrom.get('playersNo')?.errors?.[positiveNumberValidator)]"
                                class="text-danger">
                                هذا الحقل مطلوب
                            </small> -->
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-between my-5">
            <button class="btn btn-primary" (click)="createTeam()">
                حفظ
            </button>
            <button class="btn btn-outline-secondary" (click)="createTeamFrom.reset()">
                إلغاء
            </button>
        </div>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>الفريق</th>
                        <th class="text-center">عدد الجمال</th>
                        <th class="text-center">اجمالي النقاط</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let team of teams">
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="bg__circle ms-3" [ngStyle]="{'background-color': team.color}"></span>
                                <span> {{ team.name }} </span>
                            </div>
                        </td>
                        <td class="text-center">{{ team.playersNo }}</td>
                        <td class="text-center">{{ team.points }}</td>
                    </tr>
            </table>
        </div>
    </div>
</div>